import { bindable, inject } from 'aurelia-framework';
import { TabService } from './tab-service';

@inject(Element, TabService)
export class TabView {
	@bindable tabViewId: string;
	@bindable activeTabId: string;

	constructor(private element: Element, private tabService: TabService) {
	}

	attached() {
		this.setTabViewId(this.element.querySelectorAll('tab-button'));
		this.setTabViewId(this.element.querySelectorAll('tab-container'));
	}

	setTabViewId(elements : NodeListOf<Element>) {
		Array.from(elements).forEach(el => {
			el['au'].controller.viewModel.tabViewId = this.tabViewId;
		});
	}
}
